import React from "react"
import { useTranslation } from "react-i18next"
import "./ShopifyTimeoutPage.scss"
import PageWrapper from "../components/page/PageWrapper"
import ErrorTitleText from "../components/text/ErrorTitleText"
import FormFooter from "../components/form/footer/FormFooter"

interface IShopifyTimeoutPageProps {}

const ShopifyTimeoutPage = ({}: IShopifyTimeoutPageProps) => {
    const { t } = useTranslation()
    return (
        <PageWrapper narrow>
            <div id="shopify-timeout-page">
                <ErrorTitleText
                    title={t("shopifyTimeoutPage.title")}
                    text={t("shopifyTimeoutPage.text")}
                    text2={t("shopifyTimeoutPage.text2")}
                />
            </div>
            <FormFooter />
        </PageWrapper>
    )
}

export default ShopifyTimeoutPage
